module.exports = __webpack_public_path__ + "img/colors.fc98c63d.svg";